import { createSelector } from '@reduxjs/toolkit';

import { PlateList } from '@paragon/contract-library';

import { useAppSelector } from '../components/hooks';
import { RootState } from '../store';

export const getMaterialSetPrototype = (state: RootState) => state.materialSetPrototype;

export const getPlateLists = createSelector([getMaterialSetPrototype], (materialSetPrototype) =>
  materialSetPrototype.status === 'loaded' ? Object.values(materialSetPrototype.plateLists) : 'loading',
);

export function usePlateList(guid: string | undefined): PlateList | 'loading' | null {
  const materialSetPrototype = useAppSelector(getMaterialSetPrototype);
  if (materialSetPrototype.status !== 'loaded') return 'loading';

  return guid ? (materialSetPrototype.plateLists[guid] ?? null) : null;
}
